// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__oAkX0","wrapper":"Error404_wrapper__Hot2P"};